import React from 'react';
import { TYPES } from 'src/components/Elements/Picture';
import BREAKPOINTS from 'src/components/HTKit/Grid/constants';
import electricalPanel from 'src/images/electrical-panel-main.png';
import electricalPanelDistance from 'src/images/electrical-panel-and-charger-distance.png';
import homeFrontDesktop from 'src/images/home-front-desktop.jpg';
import homeFrontDesktopWebp from 'src/images/home-front-desktop.webp';
import homeFrontMobile from 'src/images/home-front-mobile.jpg';
import homeFrontMobileWebp from 'src/images/home-front-mobile.webp';

export const MEDIA_SOURCES = [
  {
    srcSet: homeFrontDesktopWebp,
    media: `(min-width: ${BREAKPOINTS.LG_GRID}px)`,
    type: TYPES.WEBP,
  },
  {
    srcSet: homeFrontDesktop,
    media: `(min-width: ${BREAKPOINTS.LG_GRID}px)`,
    type: TYPES.JPG,
  },
  {
    srcSet: homeFrontMobileWebp,
    media: `(max-width: ${BREAKPOINTS.LG_GRID}px)`,
  },
  {
    srcSet: homeFrontMobile,
    media: `(max-width: ${BREAKPOINTS.LG_GRID}px)`,
  },
];

/*
----------------------------------------------
  For PreQuestionLabelWithHint
----------------------------------------------
*/

// As a workaround, these BE values are hardcorded here. Based on these keys,
// throw up a modal with the corresponding message.
export const EV_FIND_HINT = 'find_hint';
export const EV_FIND_MEASURE = 'find_measure';

export const EV_MODALS = {
  [EV_FIND_HINT]: {
    hintText: 'How to find it',
    header: 'How to find your electrical panel',
    body:
      "Think of the main electrical panel as the 'heart' of your home's electrical system. It's usually a gray or metal box, often found in utility rooms, basements, or garages. In some homes, especially those without a basement or garage, it might be in a closet or a designated space on an external wall.",
    img: electricalPanel,
  },
  [EV_FIND_MEASURE]: {
    hintText: 'How to measure',
    header: 'How to measure distance between your panel and charger',
    body: (
      <>
        {
          'To estimate wire run length, imagine drawing a line from your electrical panel along walls, ceilings, and around corners to reach your charger.'
        }
        <br />
        <br />
        {
          'If your electrical panel is located in a different structure from your preferred charger location (e.g. your house vs. a detached garage), be sure to measure along the ground between the two structures as well.'
        }
      </>
    ),
    img: electricalPanelDistance,
  },
};

export const isEVHint = (hint) => [EV_FIND_HINT, EV_FIND_MEASURE].includes(hint);

/*
----------------------------------------------
  End For PreQuestionLabelWithHint
----------------------------------------------
*/
